import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/macro';
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from 'react-share';
import {
  faFacebookF,
  faLinkedin,
  faPinterest,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { faCheckCircle, faEnvelope, faLink } from '@fortawesome/free-solid-svg-icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import classNames from 'classnames';
import styles from '../../boardOne/BragifyEmbed.module.css';
import { AnalyticsEvents, AnalyticsScores, ShareNetworks } from '../../consts';
import { getMediaType } from '../../utils';

let timeoutInstance;

const ModalShareButtons = ({
  item,
  shareURL,
  options,
  verticalAlign = false,
  index,
  embedType,
}) => {
  const [copyVisible, setCopyVisible] = useState(false);
  const [copyUrl, setCopyUrl] = useState('');
  const urlWithReferrer = new URL(shareURL);
  urlWithReferrer.searchParams.set('giggReferrer', document.referrer);
  urlWithReferrer.searchParams.set('giggReferringItemId', item.id);
  setCopyUrl(urlWithReferrer.href);

  const socialShareClickHandler = (network) => {
    giggAnalytics.logEvent(AnalyticsEvents.SHARE_POST, {
      boardId: __gigg.accountId,
      boardType: embedType,
      folderId: __gigg.folderId,
      postIndex: index,
      postId: item.id,
      postType: item.service,
      mediaType: getMediaType(item.media),
      isCarousel: item.media?.length > 1,
      shareMethod: network,
      scoreWeight: AnalyticsScores.SHARE_POST,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
      inViewEvent: {
        _id: window.latestViewEvent?._id,
        createdDate: window.latestViewEvent?.createdDate,
      },
    });
  };

  const linkHandler = () => {
    setCopyVisible(true);
    socialShareClickHandler(ShareNetworks.LINK);
    timeoutInstance = setTimeout(() => {
      setCopyVisible(false);
    }, 4000);
  };

  const emailHandler = () => {
    window.open(`mailto:?subject=${options.shareTitle || ''}&body=${window.location.href}`);
    socialShareClickHandler(ShareNetworks.EMAIL);
  };

  useEffect(() => {
    return () => {
      window.clearTimeout(timeoutInstance);
    };
  }, []);

  return (
    <div
      className={classNames(styles['bragify-modal-share'], {
        [styles['bragify-modal-share-vertical']]: verticalAlign,
      })}
    >
      <FacebookShareButton
        url={shareURL}
        className={[styles.btn, styles['btn-share'], styles.facebook].join(' ')}
        onClick={() => {
          socialShareClickHandler(ShareNetworks.FACEBOOK);
        }}
      >
        <FontAwesomeIcon icon={faFacebookF} />
      </FacebookShareButton>
      <TwitterShareButton
        url={shareURL}
        className={[styles.btn, styles['btn-share'], styles.twitter].join(' ')}
        onClick={() => {
          socialShareClickHandler(ShareNetworks.TWITTER);
        }}
      >
        <FontAwesomeIcon icon={faTwitter} />
      </TwitterShareButton>
      {item.media && item.media[0] && (
        <PinterestShareButton
          url={shareURL}
          className={[styles.btn, styles['btn-share'], styles.pinterest].join(' ')}
          media={item.media[0].medium}
          onClick={() => {
            socialShareClickHandler(ShareNetworks.PINTEREST);
          }}
        >
          <FontAwesomeIcon icon={faPinterest} />
        </PinterestShareButton>
      )}
      <LinkedinShareButton
        url={shareURL}
        className={[styles.btn, styles['btn-share'], styles.linkedin].join(' ')}
        onClick={() => {
          socialShareClickHandler(ShareNetworks.LINKEDIN);
        }}
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </LinkedinShareButton>
      <button
        type="button"
        aria-label="email"
        className={[styles.btn, styles['btn-share'], styles.email].join(' ')}
        onClick={emailHandler}
      >
        <FontAwesomeIcon icon={faEnvelope} />
      </button>
      <CopyToClipboard text={copyUrl} onCopy={linkHandler}>
        <button
          type="button"
          aria-label="copy link"
          className={[styles.btn, styles['btn-share'], styles.copy].join(' ')}
        >
          <FontAwesomeIcon icon={faLink} />
          {copyVisible ? (
            <div className={[styles['copy-confirmation']]}>
              <FontAwesomeIcon icon={faCheckCircle} />
              <Trans>Link copied to clipboard</Trans>
            </div>
          ) : (
            ''
          )}
        </button>
      </CopyToClipboard>
    </div>
  );
};

export default ModalShareButtons;
